import React from 'react';

function Contact() {
    return (
        <section id='contact-link' className="tc-contact-style5">
            <div className="container">
                <div className="content">
                    <div className="row justify-content-between">
                        <div className="col-lg-5">
                            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
                                <h2 className="fsz-60 text-uppercase fw-400 mb-50 js-splittext-lines">
                                    Ready to <span className="color-brown1">scale?</span>
                                </h2>
                                <h6 className="color-brown1 text-uppercase fsz-20 lh-4 mb-30 js-splittext-lines">
                                    Let’s align your real estate with your business goals.
                                </h6>
                                <p className="fsz-16 color-999 mb-50">
                                    Whether you are looking for office expansion, land acquisition, or portfolio optimization,
                                    our advisory-led approach ensures your real estate works for you.
                                </p>
                                <ul className="contact-info">
                                    <li className="mb-20">
                                        <span className="color-999 text-uppercase fsz-12 d-block mb-1"> Email us </span>
                                        <a href="mailto:hello@mavinsky.com" className="fsz-18 fw-500"> hello@mavinsky.com </a>
                                    </li>
                                    <li>
                                        <span className="color-999 text-uppercase fsz-12 d-block mb-1"> Call us </span>
                                        <a href="tel:+917899009244" className="fsz-18 fw-500"> +91 78990 09244  </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <form action="https://api.web3forms.com/submit" method="POST" className="form mt-5 mt-lg-0 wow fadeInUp slow border border-brown1 radius-7 p-40" data-wow-delay="0.4s">
                                <input type="hidden" name="access_key" value="088d88ce-d5a4-4f84-bc22-532a57f8c814" />
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group mb-30">
                                            <label className="text-uppercase fsz-12 mb-10"> Full name </label>
                                            <input type="text" name="name" className="form-control border-brown1" placeholder="Your name" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group mb-30">
                                            <label className="text-uppercase fsz-12  mb-10"> Email address </label>
                                            <input type="email" name="email" className="form-control border-brown1" placeholder="Your email address" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group mb-30">
                                            <label className="text-uppercase fsz-12  mb-10"> Phone number </label>
                                            <input type="text" name="phone" className="form-control border-brown1" placeholder="Your phone number" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group mb-30">
                                            <label className="text-uppercase fsz-12  mb-10"> Message </label>
                                            <textarea name="message" rows="4" className="form-control border-brown1" placeholder="How can we help?" required></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-30">
                                    <span style={{ color: "#000" }}> Send Inquiry </span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
